
import { Injectable } from '@angular/core';
import { ResourceService } from 'src/app/global/services/resource.service';
import { AuditoriaContrato } from '../domain/auditoria-contrato.model';
import { HttpClient } from '@angular/common/http';
import { WEB_API } from 'src/app/global/services/web-api';
import { AuditoriaContratoSerializer } from '../serializables/auditoria-contrato.serializer';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ReturnAPI, Page } from '../domain/return-api.model';
import { Observable } from 'rxjs';
import { Produto } from '../domain/produto.model';

@Injectable()
export class AuditoriaContratoService extends ResourceService<AuditoriaContrato> {
  static RESOURCE = 'auditoria-contrato';
  produto: Produto;
  produtoId: string;

  constructor(private http: HttpClient) {
    super(http, `${WEB_API}`, `${AuditoriaContratoService.RESOURCE}`, new AuditoriaContratoSerializer(AuditoriaContrato));
  }

  findAll(queryOption: QueryOptions): Observable<ReturnAPI<Page<AuditoriaContrato>>> {
    this.getProduto();
    return this.httpClient.get<ReturnAPI<Page<AuditoriaContrato>>>(
      `${WEB_API}/${AuditoriaContratoService.RESOURCE}?${queryOption.toQueryString()}&${this.produtoId}`,
    );
  }

  getProduto(): void {
    if (sessionStorage.getItem('produto')) {
      this.produto = JSON.parse(sessionStorage.getItem('produto'));
      this.produtoId = Number.isInteger(this.produto.id) ? 'produtoId=' + this.produto.id : '';
    }
  }
}
